import { render, staticRenderFns } from "./News.vue?vue&type=template&id=0d84fb6e&scoped=true&"
import script from "./News.vue?vue&type=script&scoped=true&lang=js&"
export * from "./News.vue?vue&type=script&scoped=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d84fb6e",
  null
  
)

export default component.exports